import React from 'react';
import PropTypes from 'prop-types';
import { numberFormatter } from '../../../../utils/number';

// The `cashDifference` represents the discrepancy in the liquidation's cash count and is unrelated to deposits.
//  The backend sends it with an inverted sign compared to how cash is typically interpreted—positive indicates a shortage, while negative indicates a surplus.
//  In the UI, it is displayed as an absolute value with its natural sign: "-" for shortages and "+" for surpluses.
const BankReconciliationCashDifferenceCell = ({ value }) => {
  if (value === null || value === undefined) return '-';

  if (value === 0)
    return (
      <span className="text-success">{numberFormatter({ value: 0 })}</span>
    );

  const missing = value > 0;

  return (
    <span
      className={
        missing
          ? 'text-danger font-weight-bold'
          : 'text-success font-weight-bold'
      }
      title={
        missing
          ? 'Faltante de caja: el arqueo de la liquidación cerró con menos efectivo del que correspondía.'
          : 'Sobrante de caja: el arqueo de la liquidación cerró con más efectivo del que correspondía.'
      }
    >
      {missing ? '-' : '+'}
      {numberFormatter({ value: Math.abs(value) })}
    </span>
  );
};

BankReconciliationCashDifferenceCell.propTypes = {
  value: PropTypes.number,
};

BankReconciliationCashDifferenceCell.defaultProps = {
  value: null,
};

export default BankReconciliationCashDifferenceCell;
